/*
 * Copyright © Scale Microgrid Solutions Operating, LLC [2023].
 * All rights reserved.
 *
 * SPDX-FileCopyrightText: ©2023 Scale Microgrid Solutions Operating, LLC <legal@scalemicrogrids.com>
 */

import React from "react";
import { Box, Typography, Dialog, DialogContent } from "@mui/material";
import PropTypes from "prop-types";

const PropertyPickerDialog = ({ open, onClose, loading, options, onSelect }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <Typography sx={{ fontSize: "16px", fontWeight: 500, mb: 2 }}>
          Select a Property
        </Typography>
        {loading && (
          <Typography sx={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.60)" }}>
            Loading properties...
          </Typography>
        )}
        {!loading && options.length === 0 && (
          <Typography sx={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.60)" }}>
            No properties available
          </Typography>
        )}
        {!loading &&
          options.map((prop) => (
            <Box
              key={prop.keyName}
              sx={{
                padding: "0.75rem",
                cursor: "pointer",
                "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
                borderBottom: "1px solid #E3E3E3",
              }}
              onClick={() => onSelect(prop)}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                {prop.displayName || prop.keyName}
              </Typography>
              {prop.description && (
                <Typography sx={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.60)" }}>
                  {prop.description}
                </Typography>
              )}
            </Box>
          ))}
      </DialogContent>
    </Dialog>
  );
};

PropertyPickerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  options: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
};

PropertyPickerDialog.defaultProps = {
  loading: false,
  options: [],
};

export default PropertyPickerDialog;

